import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatRupiah } from "@/lib/constants";
import { AlertTriangle } from "lucide-react";

const Sec = ({ title, rows, total }) => (
  <div className="mt-3 rounded-xl border border-[#E2E5EA] bg-white">
    <div className="flex justify-between border-b border-[#E2E5EA] px-3 py-2 text-[14px] font-extrabold text-[#111827]"><span>{title}</span><span>{formatRupiah(total)}</span></div>
    {rows.length === 0 ? <div className="px-3 py-2 text-[13px] text-[#94A3B8]">Belum ada jurnal</div> : rows.map((r) => <div key={r.account_code} className="flex justify-between px-3 py-1.5 text-[13px]"><span><b className="font-mono text-[#1E3A5F]">{r.account_code}</b> · {r.account_name}</span><span>{formatRupiah(r.amount)}</span></div>)}
  </div>
);

export function FinStatement({ kind }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(kind === "pnl" ? "/accounting/pnl" : "/accounting/balance-sheet").then((r) => setD(r.data)).catch(() => {}); }, [kind]);
  if (!d) return <p className="py-6 text-sm text-gray-500">Memuat…</p>;
  return (
    <div data-testid={`fin-statement-${kind}`} className="max-w-3xl">
      {!d.official && (
        <div data-testid="fin-statement-incomplete" className="mt-2 rounded-xl border-2 border-amber-400 bg-amber-50 p-3">
          <div className="flex items-center gap-2 text-[15px] font-extrabold text-amber-800"><AlertTriangle size={18} />DATA BELUM LENGKAP — bukan laporan resmi</div>
          <ul className="mt-1 list-disc pl-5 text-[13px] text-amber-900">{d.gaps.map((g) => <li key={g}>{g}</li>)}</ul>
        </div>
      )}
      <p className="mt-2 text-[12px] text-[#475569]">Sumber: jurnal berstatus POSTED{kind === "pnl" ? ` · periode ${d.date_from || "awal"} s/d ${d.date_to || "hari ini"}` : ` · per ${d.date_to || "hari ini"}`}</p>
      {kind === "pnl" ? <>
        <Sec title="Pendapatan" rows={d.revenue} total={d.total_revenue} />
        <Sec title="HPP" rows={d.cogs} total={d.total_cogs} />
        <div className="mt-2 flex justify-between px-3 text-[14px] font-bold"><span>Laba Kotor</span><span>{formatRupiah(d.gross_profit)}</span></div>
        <Sec title="Beban" rows={d.expenses} total={d.total_expense} />
        <div data-testid="pnl-net" className="mt-2 flex justify-between rounded-xl bg-[#F4F5F7] px-3 py-2 text-[15px] font-extrabold"><span>{d.official ? "Laba / Rugi Bersih" : "Hasil Sementara (belum resmi)"}</span><span>{formatRupiah(d.net_result)}</span></div>
      </> : <>
        <Sec title="Aset" rows={d.assets} total={d.total_assets} />
        <Sec title="Kewajiban" rows={d.liabilities} total={d.total_liabilities} />
        <Sec title="Ekuitas" rows={d.equity} total={d.total_equity} />
        <div className="mt-2 flex justify-between px-3 text-[14px] font-bold"><span>Laba berjalan (dari jurnal)</span><span>{formatRupiah(d.current_earnings)}</span></div>
        <div data-testid="bs-balanced" className={`mt-2 rounded-xl px-3 py-2 text-[14px] font-extrabold ${d.balanced ? "bg-emerald-50 text-emerald-800" : "bg-rose-50 text-rose-800"}`}>{d.balanced ? "Aset = Kewajiban + Ekuitas + Laba berjalan" : "Tidak seimbang / ada akun belum ter-mapping"}</div>
      </>}
    </div>
  );
}
